<template>
    <div class="costomer-series-manage">
        <Paper class="costomer-series-manage-paper">
            <list-layout-paper>
                <template slot="header-search" class="searchBox">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        :showResetBtn="true"
                        @search-change="contractList.searchList"
                    />
                </template>
                <template slot="header-button">
                    <lotsButton
                        type="primary"
                        size="mini"
                        title="刷新"
                        @click="refresh"
                        plain>
                        <span class="icon iconfont icon-refresh"></span>
                    </lotsButton>
                    <el-tooltip effect="dark" :content="'列配置'" placement="bottom">
                        <el-button
                        icon="iconfont icon-list_install"
                        type="primary"
                        size="mini"
                        :title="'列配置'"
                        @click="showColumnConfigDialog"
                        plain />
                    </el-tooltip>
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <table-box
                        ref="clientOrder"
                        :height="tableHeight"
                        v-loading="contractList.tableLoading"
                        :selection="config.selection"
                        :index="config.index"
                        :columns="config.tableData.columns"
                        :rows="contractList.totalData">
                        <template v-slot:col-append="{ col, row }">
                            <div v-if="col.prop === 'industryStatus'">{{codesToNames(row[col.prop], dictData[col.optionsKey])}}</div>
                        </template>
                    </table-box>
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="contractList.sizeChange"
                        :current-page.sync="contractList.pageNo"
                        @current-change="contractList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="contractList.pageTotal" >
                    </lots-pagination>
                </template>
            </list-layout-paper>
            <!-- 表格列配置弹框 -->
            <column-config
                :pageID="config.name"
                :initColumns="config.tableData.columns"
                ref="otpColumnConfig"
                @header-change="config.tableData.columns = $event"
            />
        </Paper>
    </div>
</template>
<script>
import { ref, reactive, onMounted, computed } from '@vue/composition-api';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import tableBox from '@/components/lots/tableBox/Index';
import { industryInfoPage } from '@mdm/api/basicSettings/industryList.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { config as configStatic } from './config';
import lotsButton from '@/components/lots/lotsButton';
import columnConfig from '@/components/lots/columnConfig/Index';
import store from '@/store';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import _ from 'lodash';

export default {
    name: 'customer',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        tableBox,
        lotsPagination,
        lotsButton,
        columnConfig
    },
    props: {},
    // eslint-disable-next-line max-lines-per-function
    setup(props, setupContext) {
        const { user } = store.getters;
        const config = reactive(configStatic);
        class ContractListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list;
                    this.pageTotal.value = res.data.totalCount;
                }
            };
        }
        const contractList = new ContractListClass({
            Api: {
                listApi: industryInfoPage // 查询接口
            }
        });
        const codesToNames = computed(() => {
            function codeToName (code, dictObj) {
                const names = [];
                const codes = String(code);
                const codesArr = codes ? codes.split(',') : [];
                if (codesArr && codesArr.length) {
                    codesArr.forEach((key) => {
                        if (dictObj && dictObj[key]) {
                            names.push(dictObj[key]); // dictData.value['SYS_BMS_BUSI_TYPE']
                        }
                    });
                }
                return names.join(',');
            };
            return codeToName;
        });
        const dictData = ref({});
        onMounted(async() => {
            const res = await getDictDataApi({
                dictCodes: 'LCRM_INDUSTRY_STATUS'
            });
            dictData.value = res.data;
            setupContext.refs.searchBox.submitSearch();
        });
        const refresh = () => {
            contractList.getList();
        };
        const searchDataFormat = (condition) => {
            if (condition.selectList && condition.selectList.length) {
                condition.crmUserCodes = condition.selectList[0].userCode;
            }
            Reflect.deleteProperty(condition, 'selectList');
            Reflect.deleteProperty(condition, 'userName');
            condition.userCode = user.userCode;
            condition.isNew = condition.isNew ? +condition.isNew : null;
            Object.keys(condition).forEach(v => {
                !condition[v] && condition[v] !== 0 && (condition[v] = undefined);
            });
            return condition;
        };
        const otpColumnConfig = ref(null);
        const showColumnConfigDialog = () => {
            otpColumnConfig.value.show(true);
        };
        return {
            config,
            contractList,
            searchDataFormat,
            refresh,
            otpColumnConfig,
            showColumnConfigDialog,
            codesToNames,
            dictData
        };
    }
};
</script>

<style lang="less">
.costomer-series-manage {
    width: 100%;
    .costomer-series-manage-paper {
        height: 100%;
    }
    .list-layout-wrapper {
        height: 100%;
    }

    .el-tabs {
        width: 100%;
    }
    .flex-layout .list-main {
        overflow: auto;
    }
    .flex-layout .table {
        overflow-y: auto;
    }
    .layout-content.costomer-series-manage-paper {
        padding: 0px 0px 0px;
    }
}
</style>
